import { useState } from "react";
import "./filterPanel.css";

const FilterSection: React.FC<{
  isCollapsed: boolean;
  title: string;
  isStatic?: boolean;
}> = (props) => {
  const [isCollapsed, setIsCollapsed] = useState(props.isCollapsed);

  const handleOnClick = () => {
    setIsCollapsed(!isCollapsed);
  };
  return !!props.isStatic ? (
    <div className="panel filter-panel-default">
      <div className="filter-panel-heading">
        <a className="panel-title">{props.title}</a>
      </div>
      <div className="panel-body">{props.children}</div>
    </div>
  ) : (
    <div className="panel filter-panel-default">
      <div className="filter-panel-heading" onClick={handleOnClick}>
        <a className="panel-title">{props.title}</a>
        {!isCollapsed ? <h1>-</h1> : <h1>+</h1>}
      </div>
      <div className={!isCollapsed ? "panel-body pb-1" : "panel-body-collapsed"}>
        {props.children}
      </div>
    </div>
  );
};

export default FilterSection;
